import { dossier } from '@dossier/models/dossier';
import { dossierAgency } from '@dossier/models/dossier-agencies';
import { dossierState } from '@dossier/models/dossier-state';
import { ruImPairDetailed } from '@dossier/models/ru-im-pair';
import {gql} from 'apollo-angular';

export const basicData = gql`
    fragment basicData on BasicData {
        dossier {
            ...dossier
        }
        dossierRuImPairs {
            ruImPairs {
                ...ruImPairDetailed
            }
        }
        dossierState {
            ...dossierState
        }
        dossierAgencies {
            ...dossierAgency
        }
        numberOfEntriesForDossierSegment {
            dossierSegment
            numberOfEntries
        }
    }
    ${dossier}
    ${ruImPairDetailed}
    ${dossierState}
    ${dossierAgency}
`;
